const hexToRGB = (hex, alpha = 1) => {
  let r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
};

const MatchItem = ({ item, styles }) => {
  const {
    leagueName,
    arena,
    time,
    homeTeamName,
    homeScoreResult,
    homeTeamLogo,
    guestTeamName,
    guestScoreResult,
    guestTeamLogo,
    eventStatus,
  } = item;
  const { date, teams, header, showLeague, showVenue, showLogos } = styles;

  const renderText = (text, className = "", maxWidth = "200px") => {
    let displayText = text ?? <>&nbsp;</>;
    const timeRegex = /^(.*?)(\s?(AM|PM))$/;
    const match = text?.match(timeRegex);

    if (match) {
      const timePart = match[1].trim();
      const meridiem = match[2].trim();

      displayText = (
        <>
          {timePart}
          <br />
          {meridiem}
        </>
      );
    }
    return (
      <div
        className={`line-clamp-2 ${className}`}
        style={{ maxWidth }}
        title={displayText}
      >
        {displayText}
      </div>
    );
  };

  const renderScore = (team, score, compareScore, teamLogo) => (
    <div
      className={`flex justify-between items-center ${
        score > compareScore && "font-bold"
      }`}
      style={{
        padding: "8px",
        borderBottom: "none",
        backgroundColor: teams.backgroundColor,
        color: teams.textColor,
        width: "280px",
        height: "56px",
      }}
    >
      {showLogos && teamLogo ? (
        <img
          src={teamLogo}
          alt={`${team} logo`}
          style={{
            marginRight: "10px",
            height: "40px",
            width: "40px",
            objectFit: "contain",
          }}
          draggable="false"
        />
      ) : (
        <div style={{ height: "40px" }} />
      )}
      {renderText(team, "text-[14px] leading-[normal] line-clamp-2", "200px")}
      <div className="flex-shrink-0 flex-grow text-right">{score ?? "-"}</div>
    </div>
  );

  const renderLive = () => (
    <div
      style={{
        display: "flex",
        width: "auto",
        height: "20px",
        padding: "4px 6px",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: "2px",
        background: "#FF0036",
        boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.12)",
        color: "#fff",
        fontSize: "14px",
      }}
    >
      <span
        style={{
          lineHeight: "16px",
          fontWeight: "500",
          letterSpacing: "1.25px",
        }}
      >
        •
      </span>
      <span>Live</span>
    </div>
  );

  return (
    <div
      className={`flex flex-col h-fit relative overflow-hidden group rounded gap-0.5`}
    >
      <div
        className={`flex justify-between`}
        style={{
          padding: "8px",
          backgroundColor: header.backgroundColor,
          color: header.textColor,
          width: "280px",
          ...(showLeague && showVenue ? { height: "84px" } : (showLeague || showVenue ? { height: "52px" } : {})),
        }}
      >
        <div className={`flex flex-col gap-0.5`} style={{ width: "210px" }}>
          {leagueName &&
            showLeague &&
            renderText(leagueName, "font-bold text-[14px] leading-[normal]")}
          {showVenue &&
            renderText(
              arena,
              leagueName && showLeague
                ? "text-[14px] leading-[normal]"
                : "font-bold text-[14px] leading-[normal]"
            )}
        </div>
        <div className="flex-shrink-0 flex-grow text-right text-[14px] leading-[normal]">
          {eventStatus === "Ongoing" ? renderLive() : renderText(time)}
        </div>
      </div>
      {renderScore(
        homeTeamName,
        homeScoreResult,
        guestScoreResult,
        homeTeamLogo
      )}
      {renderScore(
        guestTeamName,
        guestScoreResult,
        homeScoreResult,
        guestTeamLogo
      )}
    </div>
  );
};

export default MatchItem;
